import { FaEnvelope, FaHome, FaInfoCircle, FaSignInAlt } from "react-icons/fa";
import { CNavBarItemT } from "./navigationType";

export const OpenNavigation: CNavBarItemT[] = [
  { href: "/", label: "Home", icon: <FaHome /> },
  { href: "/about-us", label: "About", icon: <FaInfoCircle /> },
  { href: "/contact", label: "Contact", icon: <FaEnvelope /> },
  {
    label: "Login",
    icon: <FaSignInAlt />,
    children: [
      { label: "Publisher Login", href: "/publisher-login" },
      { label: "Reviewer Login", href: "/reviewers-login" },
      { label: "Author Login", href: "/author-login" },
    ],
  },
  { href: "/signup", label: "Signup", icon: <FaEnvelope /> },
];
